import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import ReactQueryProvider, { client } from "context/query";
import { BrowserRouter } from "react-router-dom";
import axios from "axios";
import config from "config";
import MuiThemeProvider from "context/theme";

const { tokenKey } = config;

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

axios.interceptors.request.use((config = {}) => {
  const token = localStorage.getItem(tokenKey);
  if (!config.headers) {
    config.headers = {};
  }
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response.status === 401) {
      console.log("401");
      localStorage.removeItem(config.tokenKey);

      client.invalidateQueries([config.userKey]);
    }
    return Promise.reject(error);
  }
);

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <React.StrictMode>
    <MuiThemeProvider>
      <ReactQueryProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ReactQueryProvider>
    </MuiThemeProvider>
  </React.StrictMode>
);
